import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ArticleHeader",
    component: () => (__SERVER__ ? require("./article-header-view") : import("./article-header-view"))
});

export default definition;
